module.exports = __webpack_public_path__ + "img/kakashi-2.bb74e452.jpg";